module.exports = __webpack_public_path__ + "img/ECV_logo_CLR.c0439d7d.svg";